import { QuestionIds } from 'onboarding/data/constants/QuestionIds';
import { Question, QuestionTypes } from 'onboarding/question/Question';

export class ImageQuestion extends Question {
  title: string;
  description: string;
  imageId: string;
  url?: string;

  constructor(
    id: QuestionIds,
    title: string,
    description: string,
    imageId: string,
    url?: string,
  ) {
    super(QuestionTypes.Image, id, true);
    this.title = title;
    this.description = description;
    this.imageId = imageId;
    this.url = url;
  }
}
